import { render, staticRenderFns } from "./Customer-myself.vue?vue&type=template&id=5b29cdbe&"
import script from "./Customer-myself.vue?vue&type=script&lang=js&"
export * from "./Customer-myself.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports